import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { getStoredToken } from "../../../utils/api";

/** Redirects to /login when no auth token is present in localStorage. */
function RequireAuth() {
  const token = getStoredToken();
  const role = (localStorage.getItem("als_role") || "").trim();

  if (!token || !role) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}

export default RequireAuth;
